module.exports = __webpack_public_path__ + "static/media/logo.a38ba30a.png";